import sessionApi, { listResults } from './apiClient';
import {
  FirearmEvidence,
  FirearmEvidenceFilters,
  FirearmEvidenceUpload,
} from '../types/firearmEvidence';

export const firearmEvidenceService = {
  listEvidence: async (filters: FirearmEvidenceFilters = {}): Promise<FirearmEvidence[]> => {
    const response = await sessionApi.get('/firearm-evidence/', { params: filters });
    return listResults<FirearmEvidence>(response.data);
  },

  getEvidence: async (id: number): Promise<FirearmEvidence> => {
    const response = await sessionApi.get(`/firearm-evidence/${id}/`);
    return response.data;
  },

  listIssuanceEvidence: async (issuanceId: number): Promise<FirearmEvidence[]> => {
    const response = await sessionApi.get(`/issuances/${issuanceId}/evidence/`);
    return listResults<FirearmEvidence>(response.data);
  },

  uploadIssuanceEvidence: async (
    issuanceId: number,
    payload: FirearmEvidenceUpload,
  ): Promise<FirearmEvidence> => {
    const formData = new FormData();
    formData.append('evidence_file', payload.file);
    if (payload.notes?.trim()) formData.append('notes', payload.notes.trim());

    const response = await sessionApi.post(`/issuances/${issuanceId}/evidence/`, formData, {
      headers: { 'Content-Type': undefined },
    });
    return response.data;
  },

  listReturnEvidence: async (returnRecordId: number): Promise<FirearmEvidence[]> => {
    const response = await sessionApi.get(`/firearm-return-records/${returnRecordId}/evidence/`);
    return listResults<FirearmEvidence>(response.data);
  },

  getPreview: async (id: number): Promise<Blob> => {
    const response = await sessionApi.get(`/firearm-evidence/${id}/preview/`, {
      responseType: 'blob',
    });
    return response.data;
  },

  downloadEvidence: async (id: number): Promise<Blob> => {
    const response = await sessionApi.get(`/firearm-evidence/${id}/download/`, {
      responseType: 'blob',
    });
    return response.data;
  },
};
